import React, {useCallback, useEffect, useMemo, useState} from 'react'
import Workspace from "components/Workspace";
import DemandOffersService from "services/DemandOffersService";
import {connect} from 'react-redux'
import Loading from "components/Loading";
import RouterPath from "libs/RouterPath";
import OfferSections from "../../../../contractor/demand/scenes/offer/components/OfferSections";
import {PurchaserOfferContextProvider} from "context/PurchaserOfferContext";
import {OfferStageTranslationsContextProvider} from "context/OfferStageTranslationsContext";
import DemandService from "services/DemandService";
import PrivilegeService from "services/PrivilegeService";

function PurchaserOfferPanel(
    {
        match,
        demandStagesList,
        demandStageSectionsList
    }) {

    const demandId = match.params.id;
    const stageId = match.params.stageId;
    const contractorDepartmentId = match.params.contractorDepartmentId;
    const [stageTranslations, setStageTranslations] = useState({});
    const supplierId = useMemo(() => {
        if (stageId && demandStagesList)
            return (demandStagesList.find(x => x.identity === parseInt(stageId)) || {supplierId: null}).supplierId
    }, [stageId, demandStagesList])

    useEffect(() => {
        if (demandStagesList) {
            if (!stageId) {
                const href = RouterPath.createPath(RouterPath.purchaserDemand.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID, {
                    id: demandId,
                    contractorDepartmentId: contractorDepartmentId,
                    stageId: demandStagesList[demandStagesList.length - 1].identity
                });
                RouterPath.redirectWithoutHistory(href);
            }
        }
        // eslint-disable-next-line
    }, [demandStagesList, stageId, contractorDepartmentId])


    useEffect(() => {
        DemandOffersService.getStages(demandId, contractorDepartmentId);
        return () => {
            DemandOffersService.clearResources(DemandOffersService.DEMAND_STAGES_LIST);
        }
    }, [demandId, contractorDepartmentId])


    useEffect(() => {
        if (stageId && supplierId) {
            DemandOffersService.getStageSections(demandId, stageId, supplierId);
            DemandOffersService.getStageTranslations(demandId, stageId, supplierId).then(resp => setStageTranslations(resp))
            DemandService.getBuyerPrivileges(demandId);
        }
        return () => {
            PrivilegeService.cleanupPrivileges(PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY);
            DemandOffersService.clearResources(DemandOffersService.DEMAND_STAGE_SECTIONS_LIST, supplierId);
        }
    }, [demandId, stageId, supplierId])

    const getStageTranslation = useCallback((trKey) => {
        return stageTranslations[trKey] || trKey;
    }, [stageTranslations]);

    return (
        <>
            {(!demandStagesList || !demandStageSectionsList || !supplierId) ? <Loading/> :
                <PurchaserOfferContextProvider value={{contractorDepartmentId: parseInt(contractorDepartmentId), supplierId: supplierId}}>
                    <OfferStageTranslationsContextProvider value={getStageTranslation}>
                        <Workspace
                            render={<>
                                <OfferSections demandStageSectionsList={demandStageSectionsList}/>
                            </>}
                        />
                    </OfferStageTranslationsContextProvider>
                </PurchaserOfferContextProvider>
            }
        </>
    )
}


export default connect((state) => ({
    demandStagesList: state.resources[DemandOffersService.DEMAND_STAGES_LIST],
    demandStageSectionsList: state.resources[DemandOffersService.DEMAND_STAGE_SECTIONS_LIST],
}), {})(PurchaserOfferPanel)